import React, { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { statusColor } from "../lib/provinces";
import { titleCase } from "../lib/format";

export const RisikoWilayah = ({ topProvinces = [], nationalStatus }) => {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    if (topProvinces.length === 0) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % topProvinces.length), 5000);
    return () => clearInterval(t);
  }, [topProvinces.length]);

  const p = topProvinces[idx];

  return (
    <div className="nms-card bottom-card risiko-wilayah" data-testid="risiko-wilayah-card">
      <div className="bc-head">
        <h3 className="bc-title">
          <AlertTriangle size={14} /> RISIKO WILAYAH
        </h3>
        <span className="bc-right-mini">
          NASIONAL :{" "}
          <span
            className="rw-status"
            style={{ color: statusColor(nationalStatus), borderColor: statusColor(nationalStatus) }}
          >
            ● {(nationalStatus || "—").toUpperCase()}
          </span>
        </span>
      </div>

      {p && (
        <div className="rw-body" data-testid="risiko-body">
          <div className="rw-left">
            <div className="rw-prov-name">{titleCase(p.name)}</div>
            <div className="rw-row">
              <div className="rw-score-box">
                <span className="rw-score-icon">⛯</span>
                <span className="rw-score-lbl">SCORE</span>
                <span className="rw-score-val">{p.score}</span>
              </div>
              <span
                className="rw-status-pill"
                style={{ color: statusColor(p.status), borderColor: statusColor(p.status) }}
              >
                <AlertTriangle size={11} /> {p.status?.toUpperCase()}
              </span>
            </div>
            <div className="rw-note">Terdeteksi fluktuasi pada indikator stabilitas wilayah.</div>
            <div className="rw-dots">
              {topProvinces.slice(0, 5).map((_, i) => (
                <span key={i} className={`rw-dot ${i === idx ? "active" : ""}`} />
              ))}
            </div>
          </div>
          <div className="rw-big-rank">{idx + 1}</div>
        </div>
      )}
    </div>
  );
};

export default RisikoWilayah;
